import React from 'react';
import { useTranslation } from 'react-i18next';
import { FeatureFlag, useFeatureFlags } from '../contexts/FeatureFlagsContext';
import MaintenancePage from '../pages/MaintenancePage';
import { isMaintenanceBypassActive } from '../utils/maintenanceBypass';

interface MaintenanceGateProps {
  children: React.ReactNode;
}

/**
 * Affiche la page Mise à jour lorsque BACKOFFICE_ACCESS est désactivé,
 * sauf si un bypass admin-handoff est actif dans localStorage.
 */
const MaintenanceGate: React.FC<MaintenanceGateProps> = ({ children }) => {
  useTranslation('common');
  const { isFeatureEnabled } = useFeatureFlags();
  const isBackofficeLocked = !isFeatureEnabled(FeatureFlag.BACKOFFICE_ACCESS);

  if (isBackofficeLocked && !isMaintenanceBypassActive()) {
    return <MaintenancePage />;
  }

  return <>{children}</>;
};

export default MaintenanceGate;
